import { createAsyncThunk, AnyAction } from "@reduxjs/toolkit"
import { ThunkDispatch } from "redux-thunk"

import i18n from "config/i18n"
import { API } from "redux/api"
import { NpsValues } from "types"

export const createNps = createAsyncThunk(
  "nps/create",
  async (values: NpsValues) => {
    const response = await API.post("/nps", { nps: values })
    return response.data
  },
)

export const makeNps = (values: NpsValues) => {
  return function (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) {
    return new Promise((resolve, reject) => {
      return dispatch(createNps(values))
        .then(
          ({ payload }) => {
            if (!payload) {
              return reject(i18n.t("notice.nps.create.failure"))
            }
          },
          () => {
            reject(i18n.t("notice.nps.create.failure"))
          },
        )
        .catch((error) => {
          reject(error)
        })
    })
  }
}
